import version from '../version.json';

export const env = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ENVIRONMENT_NAME: process.env.REACT_APP_ENVIRONMENT_NAME ?? '',
  REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN ?? '',
  REACT_APP_INTERCOM_APP_ID: process.env.REACT_APP_INTERCOM_APP_ID ?? '',
  REACT_APP_SEGMENT_WRITE_KEY: process.env.REACT_APP_SEGMENT_WRITE_KEY ?? '',
  REACT_APP_PENDO_APP_KEY: process.env.REACT_APP_PENDO_APP_KEY ?? '',
  REACT_APP_SENTRY_DEBUG: process.env.REACT_APP_SENTRY_DEBUG ?? '',
  REACT_APP_SENTRY_REPORTING: process.env.REACT_APP_SENTRY_REPORTING ?? '',
  REACT_APP_RELEASE_VERSIONS: version.version ?? '',
  REACT_APP_SLACK_REPORTING_URL:
    process.env.REACT_APP_SLACK_REPORTING_URL ?? '',
  SENTRY_AUTH_TOKEN: process.env.SENTRY_AUTH_TOKEN ?? '',
  ONE_SCHEMA_CLIENT_ID:
    process.env.ONE_SCHEMA_CLIENT_ID ?? 'edc908f7-2883-45c7-98d3-5a436ab134f8', //remove
};
